enum GroupWidgetTargetType {
  Range = 'TARGET_RANGE',
  Value = 'SPECIFIC_TARGET',
  None = 'NOT_SET',
}

export default GroupWidgetTargetType;
